module.exports = __webpack_public_path__ + "static/img/5.42e2167.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/7/5.png
// module id = 283
// module chunks = 0